<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
  <div class="modal-container" @click.stop>
      <button @click.stop="closeModal" class="close-button" type="button">
        <img class="cross" src="../../assets/images/cross.svg" alt="Close" />
      </button>

      <div class="modal-header">
        <div class="header-content">
          <h2 class="modal-title">{{ modalTitle }}</h2>
          <p class="modal-subtitle">{{ getTrialMessage() }}</p>
        </div>
       <!-- <div class="toggle-section">
          <div class="discount-badge">{{$t('discount_on_annual_payments')}}</div>
          <div class="annual-toggle">
            <svg width="60" height="46" viewBox="0 0 60 46" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_8141_23649)">
                <path d="M5.39102 9.60032C5.02679 12.7838 4.77976 16.0665 6.36548 18.9857C7.78452 21.5931 10.2647 23.4635 12.9707 24.5809C15.9178 25.7964 19.2244 25.9964 22.3573 25.5308C23.9689 25.2914 25.5484 24.8926 27.0914 24.3716C27.8561 24.1101 28.615 23.821 29.3604 23.5102C30.1058 23.1994 30.863 22.8847 31.4608 22.331C31.9695 21.8553 32.2893 21.1599 32.2023 20.4595C32.1116 19.7178 31.5219 19.2003 30.8655 18.9201C29.3823 18.2877 27.4994 18.5368 25.9961 18.9991C23.0861 19.8891 20.0833 22.3842 20.0898 25.6728C20.0963 28.9613 22.9458 31.3751 25.8148 32.5212C28.6838 33.6673 32.2398 34.1523 35.4531 34.216C41.5516 34.339 47.6835 32.8858 53.0115 29.8933C53.6728 29.5248 54.3146 29.1267 54.9429 28.7069C55.6659 28.2269 53.9392 27.5691 53.4335 27.8935C48.9457 30.7862 43.8527 32.6012 38.5242 33.0777C35.8944 33.3113 33.2296 33.236 30.6285 32.7937C27.8213 32.3202 24.7333 31.5361 22.9986 29.0836C22.2188 27.9809 21.7986 26.6175 22.0133 25.2667C22.228 23.916 23.0438 22.6151 24.0908 21.6638C25.1378 20.7125 26.3966 20.0911 27.7337 19.771C28.3068 19.6339 28.9069 19.55 29.4985 19.5603C29.7717 19.5664 30.0253 19.5624 30.1964 19.7976C30.4007 20.0743 30.39 20.4536 30.3109 20.7734C29.9785 22.0937 28.2137 22.5659 27.096 22.9977C25.7515 23.5162 24.3722 23.948 22.9644 24.2617C20.3832 24.8357 17.6183 24.9955 15.0448 24.2762C12.3458 23.5226 9.87438 21.7996 8.38682 19.4138C6.60403 16.5619 6.86156 13.1909 7.21212 9.99547C7.28399 9.33164 5.46443 8.99153 5.39094 9.61015L5.38702 9.60815L5.39102 9.60032Z" fill="black"/>
                <path d="M48.3795 28.1834L53.6676 27.3312L56.2142 26.922C56.9227 26.8094 57.7423 26.5562 58.4524 26.7503L57.6211 26.2133C57.7096 26.9884 57.1869 27.7431 56.8106 28.3752C56.3825 29.0894 55.9232 29.7876 55.4677 30.4879C54.5548 31.8923 53.5609 33.3589 53.071 34.9788C52.8874 35.5907 54.6281 35.9597 54.8921 35.3641C55.6321 33.6891 56.5498 32.1688 57.5462 30.6393C58.0335 29.8862 58.5247 29.1351 58.9573 28.3443C59.3101 27.7003 59.5741 27.0949 59.4913 26.3474C59.4544 26.0326 58.8934 25.875 58.66 25.8103C57.7813 25.5697 56.8999 25.6731 56.0123 25.8177C55.0342 25.9754 54.0561 26.1331 53.074 26.2888L47.1994 27.2369C46.796 27.3026 46.7951 27.6721 47.0588 27.9002C47.4122 28.2036 47.9446 28.2528 48.3854 28.1815L48.3795 28.1834Z" fill="black"/>
              </g>
              <defs>
                <clipPath id="clip0_8141_23649">
                  <rect width="56.2622" height="21" fill="white" transform="translate(9.82422 0.859375) rotate(27)"/>
                </clipPath>
              </defs>
            </svg>
            <span class="toggle-label" :class="{ active: !isAnnual }">{{$t('monthly')}}</span>
            <Switch v-model="isAnnual" />
            <span class="toggle-label" :class="{ active: isAnnual }">{{$t('yearly')}}</span>
          </div>
        </div>
        !-->
      </div>

      <div v-if="isPendingPaymentMode" class="pending-info-bar">
        <span>{{ $t('payment_pending_modal_subtitle') }}</span>
      </div>

      <div class="pricing-cards">
        <div
            v-for="packageItem in sortedPackages"
            :key="packageItem && packageItem.packageId ? packageItem.packageId : 'default'"
            :class="['pricing-card', getCardClass(packageItem), { 'pending-package-highlight': isPendingPackageCard(packageItem) }]"
        >
          <div v-if="isPendingPackageCard(packageItem)" class="pending-badge">
            {{ $t('payment_pending_badge') }}
          </div>
          <div class="plan-header">
            <div class="plan-name-wrapper">
              <h3 class="plan-name">{{ packageItem && packageItem.name ? packageItem.name : 'Paket Adı' }}</h3>
              <p class="plan-description">{{ packageItem && packageItem.shortDescription ? packageItem.shortDescription : '' }}</p>
            </div>
            <div class="plan-icon">
              <svg v-if="getPlanIcon(packageItem && packageItem.name ? packageItem.name : '') === 'starter'" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M26.1921 10.4173C26.1921 14.6057 22.7971 18.0007 18.6087 18.0007C18.4104 18.0007 18.2004 17.989 18.0021 17.9773C17.7104 14.279 14.747 11.3157 11.0487 11.024C11.037 10.8257 11.0254 10.6157 11.0254 10.4173C11.0254 6.22898 14.4204 2.83398 18.6087 2.83398C22.7971 2.83398 26.1921 6.22898 26.1921 10.4173Z" fill="#3DA33E"/>
                <path opacity="0.4" d="M18.026 18.5833C18.026 22.7717 14.631 26.1667 10.4427 26.1667C6.25438 26.1667 2.85938 22.7717 2.85938 18.5833C2.85938 14.395 6.25438 11 10.4427 11C10.641 11 10.851 11.0117 11.0494 11.0233C14.7477 11.315 17.7111 14.2783 18.0027 17.9767C18.0144 18.175 18.026 18.385 18.026 18.5833Z" fill="#3DA33E"/>
                <path d="M9.41539 17.556L10.4421 15.666L11.4687 17.556L13.3587 18.5827L11.4687 19.6094L10.4421 21.4993L9.41539 19.6094L7.52539 18.5827L9.41539 17.556Z" fill="#3DA33E"/>
              </svg>

              <svg v-else-if="getPlanIcon(packageItem && packageItem.name ? packageItem.name : '') === 'advanced'" width="29" height="29" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" d="M16.8736 3.86309L11.4019 2.99976C6.84028 2.28809 4.72861 3.82809 4.00528 8.38976L3.14194 13.8614C2.67528 16.8481 3.16528 18.7848 4.85694 19.9631C5.74361 20.5931 6.95694 21.0131 8.53194 21.2581L14.0036 22.1214C18.5653 22.8331 20.6769 21.2931 21.4003 16.7314L22.2519 11.2598C22.3919 10.3614 22.4503 9.55643 22.4036 8.84476C22.2519 5.92809 20.5369 4.43476 16.8736 3.86309ZM10.2819 11.4114C8.91694 11.4114 7.80861 10.3031 7.80861 8.94976C7.80861 7.58476 8.91694 6.47643 10.2819 6.47643C11.6353 6.47643 12.7436 7.58476 12.7436 8.94976C12.7436 10.3031 11.6353 11.4114 10.2819 11.4114Z" fill="#1C3CD5"/>
                <path d="M24.5838 16.2132L22.8338 21.4748C21.3755 25.8615 19.0421 27.0282 14.6555 25.5698L9.3938 23.8198C6.74547 22.9448 5.27547 21.7315 4.85547 19.9582C5.74214 20.5882 6.95547 21.0082 8.53047 21.2532L14.0021 22.1165C18.5638 22.8282 20.6755 21.2882 21.3988 16.7265L22.2505 11.2548C22.3905 10.3565 22.4488 9.55151 22.4021 8.83984C25.1905 10.3215 25.7971 12.5615 24.5838 16.2132Z" fill="#1C3CD5"/>
                <path d="M12.7436 8.94404C12.7436 10.2974 11.6353 11.4057 10.2819 11.4057C8.91693 11.4057 7.80859 10.2974 7.80859 8.94404C7.80859 7.57904 8.91693 6.4707 10.2819 6.4707C11.6353 6.4707 12.7436 7.57904 12.7436 8.94404Z" fill="#1C3CD5"/>
              </svg>

              <svg v-else width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.6" d="M11.7956 5.16602C11.7023 5.51602 11.6673 5.90102 11.6673 6.33268V9.83268H5.83398V7.49935C5.83398 6.21602 6.88398 5.16602 8.16732 5.16602H11.7956Z" fill="#6E3FF3"/>
                <path d="M11.6673 22.6673V9.83398H5.83398C3.50065 9.83398 2.33398 11.0007 2.33398 13.334V22.6673C2.33398 25.0007 3.50065 26.1673 5.83398 26.1673H15.1673C12.834 26.1673 11.6673 25.0007 11.6673 22.6673ZM7.87565 20.334C7.87565 20.8123 7.47898 21.209 7.00065 21.209C6.52232 21.209 6.12565 20.8123 6.12565 20.334V15.6673C6.12565 15.189 6.52232 14.7923 7.00065 14.7923C7.47898 14.7923 7.87565 15.189 7.87565 15.6673V20.334Z" fill="#6E3FF3"/>
                <path opacity="0.4" d="M16.3327 26.1673H15.166C12.8327 26.1673 11.666 25.0007 11.666 22.6673V6.33398C11.666 4.00065 12.8327 2.83398 15.166 2.83398H22.166C24.4993 2.83398 25.666 4.00065 25.666 6.33398V22.6673C25.666 25.0007 24.4993 26.1673 22.166 26.1673H20.9993" fill="#6E3FF3"/>
                <path d="M21.0007 21.5007V26.1673H16.334V21.5007C16.334 20.859 16.859 20.334 17.5007 20.334H19.834C20.4757 20.334 21.0007 20.859 21.0007 21.5007Z" fill="#6E3FF3"/>
                <path d="M16.334 16.5404C15.8557 16.5404 15.459 16.1437 15.459 15.6654V9.83203C15.459 9.3537 15.8557 8.95703 16.334 8.95703C16.8123 8.95703 17.209 9.3537 17.209 9.83203V15.6654C17.209 16.1437 16.8123 16.5404 16.334 16.5404Z" fill="#6E3FF3"/>
                <path d="M21 16.5404C20.5217 16.5404 20.125 16.1437 20.125 15.6654V9.83203C20.125 9.3537 20.5217 8.95703 21 8.95703C21.4783 8.95703 21.875 9.3537 21.875 9.83203V15.6654C21.875 16.1437 21.4783 16.5404 21 16.5404Z" fill="#6E3FF3"/>
              </svg>
            </div>
          </div>

          <div class="pricing-section">
            <div v-if="packageItem && packageItem.isEnterprise" class="custom-pricing">
              <span class="custom-price">{{$t('get_a_quote')}}</span>
            </div>
            <div v-else-if="getUpgradeInfo(packageItem) && !isDowngrade(packageItem)" class="upgrade-pricing">
              <div class="original-price">
                <span class="original-currency">$</span>
                <span class="price-strikethrough">{{ getPrice(packageItem) }}</span>
                <span class="original-period">/{{ isAnnual ? 'yıl' : 'ay' }}</span>
              </div>
              <div class="price-container upgrade-amount">
                <span class="currency">$</span>
                <span class="price">{{ getUpgradeAmountDue(packageItem) }}</span>
              </div>
              <div v-if="getUpgradeAmountDueTRY(packageItem)" class="price-try">
                ≈ {{ formatPriceTRY(getUpgradeAmountDueTRY(packageItem)) }} ₺
              </div>
              <div v-if="getUpgradeInfo(packageItem).proratedCredit > 0" class="upgrade-badge">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7 1.75L7 12.25" stroke="#3DA33E" stroke-width="1.5" stroke-linecap="round"/>
                  <path d="M3.5 5.25L7 1.75L10.5 5.25" stroke="#3DA33E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>{{ $t('prorated_credit') }}: <strong>-${{ getUpgradeInfo(packageItem).proratedCredit }}</strong></span>
              </div>
              <div v-if="getUpgradeInfo(packageItem).proratedCredit > 0" class="upgrade-addons-note">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="7" cy="7" r="6" stroke="#175CD3" stroke-width="1.2"/>
                  <path d="M7 6.5V9.5" stroke="#175CD3" stroke-width="1.2" stroke-linecap="round"/>
                  <circle cx="7" cy="4.75" r="0.75" fill="#175CD3"/>
                </svg>
                <span>{{ $t('upgrade_addons_preserved') }}</span>
              </div>
            </div>
            <div v-else>
              <div class="price-container">
                <span class="currency">$</span>
                <span class="price">{{ getPrice(packageItem) }}</span>
                <span class="period">/{{ isAnnual ? 'yıl' : 'ay' }}</span>
              </div>
              <div v-if="getPriceTRY(packageItem)" class="price-try">
                ≈ {{ formatPriceTRY(getPriceTRY(packageItem)) }} ₺
              </div>
            </div>
          </div>

          <div class="plan-button-wrapper">
            <button
                :class="['plan-button', getButtonClass(packageItem)]"
                :disabled="isUpgrading || isCurrentPlan(packageItem) || isDowngrade(packageItem)"
                @click.stop="openPaymentModal(packageItem)"
            >
              {{ getButtonDisplayText(packageItem) }}
            </button>
            <div class="billing-info-wrapper">
              <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.6 3.09961H13.4C13.5591 3.09961 13.7117 3.16282 13.8243 3.27535C13.9368 3.38787 14 3.54048 14 3.69961V13.2996C14 13.4587 13.9368 13.6114 13.8243 13.7239C13.7117 13.8364 13.5591 13.8996 13.4 13.8996H2.6C2.44087 13.8996 2.28826 13.8364 2.17574 13.7239C2.06321 13.6114 2 13.4587 2 13.2996V3.69961C2 3.54048 2.06321 3.38787 2.17574 3.27535C2.28826 3.16282 2.44087 3.09961 2.6 3.09961ZM12.8 7.89961H3.2V12.6996H12.8V7.89961ZM12.8 6.69961V4.29961H3.2V6.69961H12.8ZM9.2 10.2996H11.6V11.4996H9.2V10.2996Z" fill="#868C98"/>
              </svg>
              <p class="billing-info">{{ getBillingInfo() }}</p>
            </div>
          </div>

          <div class="features-section">
            <h4 class="features-title">{{ getMainFeatureTitle(packageItem) }}</h4>
            <ul class="features-list">
              <li v-for="feature in getMainFeatures(packageItem)" :key="feature">
                <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8.49956 12.8772L15.3936 5.98242L16.4548 7.04292L8.49956 14.9982L3.72656 10.2252L4.78706 9.16467L8.49956 12.8772Z" fill="#101828"/>
                </svg>
                {{ feature }}
              </li>
            </ul>
          </div>

          <div class="device-icons">
            <div v-if="shouldShowBothIcons(packageItem)" style="display: flex; gap: 8px; align-items: center">
              <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.80004 16.1004H19.2V6.20039H4.80004V16.1004ZM12.9 17.9004V19.7004H16.5V21.5004H7.50004V19.7004H11.1V17.9004H3.89284C3.77465 17.8997 3.65777 17.8757 3.54889 17.8297C3.44001 17.7837 3.34127 17.7167 3.25833 17.6325C3.17539 17.5484 3.10988 17.4486 3.06556 17.3391C3.02123 17.2295 2.99897 17.1123 3.00004 16.9941V5.30669C3.00004 4.80629 3.40954 4.40039 3.89284 4.40039H20.1072C20.6004 4.40039 21 4.80449 21 5.30669V16.9941C21 17.4945 20.5905 17.9004 20.1072 17.9004H12.9Z" fill="#101828"/>
              </svg>

              <svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.49922 2.3V16.7H11.4992V2.3H2.49922ZM1.59922 0.5H12.3992C12.6379 0.5 12.8668 0.594821 13.0356 0.763604C13.2044 0.932387 13.2992 1.16131 13.2992 1.4V17.6C13.2992 17.8387 13.2044 18.0676 13.0356 18.2364C12.8668 18.4052 12.6379 18.5 12.3992 18.5H1.59922C1.36052 18.5 1.13161 18.4052 0.962823 18.2364C0.79404 18.0676 0.699219 17.8387 0.699219 17.6V1.4C0.699219 1.16131 0.79404 0.932387 0.962823 0.763604C1.13161 0.594821 1.36052 0.5 1.59922 0.5ZM6.99922 14C7.23791 14 7.46683 14.0948 7.63561 14.2636C7.8044 14.4324 7.89922 14.6613 7.89922 14.9C7.89922 15.1387 7.8044 15.3676 7.63561 15.5364C7.46683 15.7052 7.23791 15.8 6.99922 15.8C6.76052 15.8 6.53161 15.7052 6.36282 15.5364C6.19404 15.3676 6.09922 15.1387 6.09922 14.9C6.09922 14.6613 6.19404 14.4324 6.36282 14.2636C6.53161 14.0948 6.76052 14 6.99922 14Z" fill="#101828"/>
              </svg>
            </div>

            <svg v-else width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.80004 16.1004H19.2V6.20039H4.80004V16.1004ZM12.9 17.9004V19.7004H16.5V21.5004H7.50004V19.7004H11.1V17.9004H3.89284C3.77465 17.8997 3.65777 17.8757 3.54889 17.8297C3.44001 17.7837 3.34127 17.7167 3.25833 17.6325C3.17539 17.5484 3.10988 17.4486 3.06556 17.3391C3.02123 17.2295 2.99897 17.1123 3.00004 16.9941V5.30669C3.00004 4.80629 3.40954 4.40039 3.89284 4.40039H20.1072C20.6004 4.40039 21 4.80449 21 5.30669V16.9941C21 17.4945 20.5905 17.9004 20.1072 17.9004H12.9Z" fill="#101828"/>
            </svg>
          </div>
        </div>
      </div>

      <div v-if="upgradeError" class="error-message">
        {{ upgradeError }}
      </div>
    <PaymentCard
        :is="PaymentCardComponent"
        v-if="isPaymentModalVisible"
        :key="selectedPackage?.packageId + '-' + Date.now()"
        :isVisible="isPaymentModalVisible"
        :selectedPackage="selectedPackage"
        :isAnnual="isAnnual"
        :paymentMethodsProp="paymentMethods"
        :billingHistoryProp="billingHistory"
        @close="closePaymentModal"
        @payment-success="onPaymentSuccess"
    />
    </div>
  </div>
</template>

<script>
import Switch from "@/components/Switch.vue";
import pricingService from '@/service/pricingService';
import PaymentCard from "@/components/modals/PaymentCardModal.vue";

export default {
  name: 'PricingPacketModal',
  components: {
    PaymentCard,
    Switch
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    urgency: {
      type: String,
      default: 'normal',
      validator: (value) => ['normal', 'warning', 'critical', 'expired', 'overdue', 'user-limit'].includes(value)
    },
    packages: {
      type: Array,
      default: () => [],
      validator: (value) => Array.isArray(value)
    },
    userPackageStatus: {
      type: Object,
      default: () => null,
      validator: (value) => value === null || typeof value === 'object'
    },
    paymentMethods: {
      type: [Array, Object],
      default: () => []
    },
    billingHistory: {
      type: [Array, Object],
      default: () => []
    }
  },
  data() {
    return {
      isAnnual: true,
      isPaymentModalVisible: false,
      selectedPackage: null,
      PaymentCardComponent: null,
      isUpgrading: false,
      upgradeError: null
    }
  },

  computed: {
    currentPackage() {
      if (!this.userPackageStatus || !Array.isArray(this.packages) || !this.packages.length) return null;
      return this.packages.find(pkg => pkg && pkg.packageId === this.userPackageStatus.currentPackageId);
    },

    currentUserPackageId() {
      return this.userPackageStatus?.currentPackageId || null;
    },

    modalTitle() {
      // Pending payment durumunda özel başlık
      if (this.userPackageStatus?.urgency === 'payment_pending'
          || this.userPackageStatus?.pendingPayment === true) {
        return this.$t('payment_pending_modal_title');
      }
      switch (this.urgency) {
        case 'critical':
          return this.$t('trial_ended');
        case 'expired':
          return this.$t('choose_plan');
        case 'warning':
          return this.$t('upgrade_plan');
        case 'overdue':
          return this.$t('payment_required');
        case 'user-limit':
          return this.$t('user_limit_exceeded');
        default:
          return this.$t('upgrade_plan');
      }
    },

    isPendingPaymentMode() {
      return this.userPackageStatus?.urgency === 'payment_pending'
          || this.userPackageStatus?.pendingPayment === true;
    },

    sortedPackages() {
      if (!Array.isArray(this.packages) || !this.packages.length) return [];

      return [...this.packages].filter(pkg => pkg !== null && pkg !== undefined).sort((a, b) => {
        if (a.isEnterprise && !b.isEnterprise) return 1;
        if (!a.isEnterprise && b.isEnterprise) return -1;

        return (a.sortOrder || 0) - (b.sortOrder || 0);
      });
    }
  },

  async mounted() {
    try {
      const PaymentCard = await import('@/components/modals/PaymentCardModal.vue');
      this.PaymentCardComponent = PaymentCard.default || PaymentCard;
    } catch (error) {
    }
  },

  methods: {
    getPrice(packageItem) {
      if (!packageItem || packageItem.isEnterprise) return this.$t('get_quote');

      const price = this.isAnnual
          ? parseFloat(packageItem.yearlyPrice || 0)
          : parseFloat(packageItem.monthlyPrice || 0);

      return Math.round(price);
    },

    getPriceTRY(packageItem) {
      if (!packageItem || packageItem.isEnterprise) return null;

      const priceTRY = this.isAnnual
          ? packageItem.yearlyPriceTRY
          : packageItem.monthlyPriceTRY;

      return priceTRY || null;
    },

    getUpgradeInfo(packageItem) {
      if (!packageItem || !packageItem.upgradeInfo) return null;
      return packageItem.upgradeInfo;
    },

    getUpgradeAmountDue(packageItem) {
      const info = this.getUpgradeInfo(packageItem);
      if (!info) return 0;

      const amount = this.isAnnual
          ? parseFloat(info.yearlyAmountDue || 0)
          : parseFloat(info.monthlyAmountDue || 0);

      return Math.round(amount);
    },

    getUpgradeAmountDueTRY(packageItem) {
      const info = this.getUpgradeInfo(packageItem);
      if (!info) return null;

      const amountTRY = this.isAnnual
          ? info.yearlyAmountDueTRY
          : info.monthlyAmountDueTRY;

      return amountTRY || null;
    },

    formatPriceTRY(price) {
      if (!price) return '';
      // Türkçe formatında binlik ayracı ile göster
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(Math.round(price));
    },

    getBillingInfo() {
      return this.isAnnual
          ? this.$t('yearly_billing')
          : this.$t('monthly_billing');
    },

    getTrialMessage() {
      if (!this.userPackageStatus) {
        return '';
      }

      // Ödeme bekleyen paket - Manuel atama yapılmış ama ödeme alınmamış
      // Bu durumda demo/trial mesajı GÖSTERİLMEMELİ
      if (this.userPackageStatus.type === 'pending_payment') {
        return this.$t('pending_payment_message') || 'Paket ataması yapıldı. Ödeme bekleniyor.';
      }

      // Ücretli paket (ödeme yapılmış) - demo mesajı gösterme
      if (this.userPackageStatus.type === 'payment' && !this.userPackageStatus.isDemo) {
        return '';
      }

      // Demo paketi mi kontrol et - sadece gerçekten demo ise
      // packages.isDemo = true OLMALI (packageType değil!)
      const isDemo = this.userPackageStatus?.isDemo === true;

      // Demo/trial paket için bitiş tarihi göster
      if (isDemo && this.userPackageStatus.trialEndDate) {
        const endDate = new Date(this.userPackageStatus.trialEndDate);
        const formattedDate = endDate.toLocaleDateString('tr-TR');
        return this.$t('trial_end_date', { date: formattedDate });
      }

      switch (this.urgency) {
        case 'warning':
          return isDemo ? this.$t('trial_warning') : '';
        case 'critical':
          return isDemo ? this.$t('trial_ending_today') : '';
        case 'expired':
          return this.$t('trial_expired');
        case 'overdue':
          return this.$t('payment_overdue');
        case 'user-limit':
          return this.$t('user_limit_message');
        default:
          // Sadece demo paket kullanıyorsa bu mesajı göster
          return isDemo ? this.$t('demo_data_warning') : '';
      }
    },

    getCardClass(packageItem) {
      if (!packageItem) return 'starter';

      const name = packageItem.name?.toLowerCase() || '';

      if (this.userPackageStatus?.currentPackageId === packageItem.packageId) {
        return 'current-plan';
      }

      if (name.includes('başlangıç')) return 'starter';
      if (name.includes('gelişmiş')) return 'advanced';
      if (name.includes('kurumsal')) return 'enterprise';
      return 'starter';
    },

    getButtonClass(packageItem) {
      if (!packageItem) return 'primary';
      if (this.isCurrentPlan(packageItem)) return 'current-disabled';
      if (this.isDowngrade(packageItem)) return 'downgrade-disabled';
      if (packageItem.isEnterprise) return 'enterprise';
      return 'primary';
    },

    getButtonText(packageItem) {
      if (!packageItem) return 'Planı Seç';

      if (this.userPackageStatus?.currentPackageId === packageItem.packageId) {
        return 'Mevcut Planınız';
      }

      if (packageItem.isEnterprise) return 'İletişime Geç';

      switch (this.urgency) {
        case 'expired':
          return 'Planı Seç';
        case 'critical':
          return 'Hemen Geç';
        case 'overdue':
          return 'Ödemeyi Tamamla';
        default:
          return 'Plana Geç';
      }
    },

    getPlanIcon(planName) {
      if (!planName) return 'enterprise';

      const name = planName.toLowerCase();

      if (name.includes('başlangıç')) return 'starter';
      if (name.includes('gelişmiş')) return 'advanced';
      return 'enterprise';
    },

    getMainFeatureTitle(packageItem) {
      if (!packageItem) return this.$t('ai_microlearning_web');

      const hasMobileApp = this.hasMobileAppSupport(packageItem);
      return hasMobileApp
          ? this.$t('ai_microlearning_mobile')
          : this.$t('ai_microlearning_web');
    },

    getMainFeatures(packageItem) {
      if (!packageItem) return [];

      const features = [];

      if (!packageItem.categories || !Array.isArray(packageItem.categories)) {
        return this.parseDescriptionFeatures(packageItem);
      }

      packageItem.categories.forEach(category => {
        if (category && category.products && Array.isArray(category.products)) {
          category.products.forEach(product => {
            if (product && product.isIncluded && product.displayText !== 'Yok') {
              let featureText = product.productName || '';

              if (product.displayText && product.displayText !== 'Var' && product.displayText !== 'true') {
                featureText += ` (${product.displayText})`;
              }

              if (featureText) {
                features.push(featureText);
              }
            }
          });
        }
      });

      return this.prioritizeFeatures(features).slice(0, 6);
    },

    parseDescriptionFeatures(packageItem) {
      if (!packageItem || !packageItem.description) return [];

      const description = packageItem.description;
      const features = [];

      const cleanDescription = description.replace(/<[^>]*>/g, '\n').split('\n').filter(line => line && line.trim());

      cleanDescription.forEach(line => {
        const trimmed = line.trim();
        if (trimmed &&
            !trimmed.includes('AI Mikroöğrenme') &&
            !trimmed.includes('paketindeki') &&
            trimmed.length > 5) {
          features.push(trimmed);
        }
      });

      return features.slice(0, 6);
    },

    prioritizeFeatures(features) {
      if (!Array.isArray(features)) return [];

      const priorityOrder = [
        'program oluşturma',
        'kullanıcı',
        'mobil uygulama',
        'web link',
        'ai',
        'video',
        'test',
        'raporlama'
      ];

      return features.sort((a, b) => {
        if (!a || !b) return 0;

        const aLower = a.toLowerCase();
        const bLower = b.toLowerCase();

        const aPriority = priorityOrder.findIndex(p => aLower.includes(p));
        const bPriority = priorityOrder.findIndex(p => bLower.includes(p));

        if (aPriority !== -1 && bPriority === -1) return -1;
        if (aPriority === -1 && bPriority !== -1) return 1;
        if (aPriority !== -1 && bPriority !== -1) return aPriority - bPriority;

        return 0;
      });
    },

    hasMobileAppSupport(packageItem) {
      if (!packageItem || !packageItem.categories || !Array.isArray(packageItem.categories)) return false;

      return packageItem.categories.some(category =>
          category && category.products && Array.isArray(category.products) &&
          category.products.some(product =>
              product && product.productKey === 'mobile_app_core' && product.isIncluded
          )
      );
    },

    closeModal() {
      this.$emit('close');
    },

    openPaymentModal(packageItem) {
      console.log('openPaymentModal called', packageItem?.name);
      if (!packageItem) return;

      const isEnterprise = packageItem.isEnterprise || (packageItem.name && packageItem.name.toLowerCase().includes('kurumsal'));
      console.log('isEnterprise:', isEnterprise);

      if (isEnterprise) {
        window.location.href = 'mailto:info@ibilityapp.com?subject=Kurumsal%20Paket%20Talebi';
        setTimeout(() => {
          window.open('https://mail.google.com/mail/?view=cm&to=info@ibilityapp.com&su=Kurumsal%20Paket%20Talebi', '_blank');
        }, 1000);
        return;
      }

      // Sadece AKTİF VE ÖDENMİŞ paketin aynısı seçilirse engelle (yeniden satın alma anlamsız).
      // Expired/cancelled/used/pending payment ise aynı paketi seçebilmeli.
      const status = this.userPackageStatus?.status;
      const isPendingPayment = this.userPackageStatus?.urgency === 'payment_pending'
          || this.userPackageStatus?.pendingPayment === true;
      const isPackageActive = status === 'active'
          && this.userPackageStatus?.isUsed !== true
          && !isPendingPayment;
      if (isPackageActive && this.userPackageStatus?.currentPackageId === packageItem.packageId) {
        return;
      }

      this.handlePayment(packageItem);
    },

    async handlePayment(packageItem) {
      this.isUpgrading = true;
      this.upgradeError = null;

      try {
        this.isPaymentModalVisible = false;
        this.selectedPackage = null;

        await this.$nextTick();

        this.selectedPackage = packageItem;
        this.isPaymentModalVisible = true;

      } catch (error) {
        this.upgradeError = this.$t('selection_failed');
      } finally {
        this.isUpgrading = false;
      }
    },

    closePaymentModal() {
      this.isPaymentModalVisible = false;
      this.selectedPackage = null;
      this.$nextTick(() => {
        this.PaymentCardComponent = null;
        this.loadPaymentCardComponent();
      });
    },

    async loadPaymentCardComponent() {
      try {
        const PaymentCard = await import('@/components/modals/PaymentCardModal.vue');
        this.PaymentCardComponent = PaymentCard.default || PaymentCard;
      } catch (error) {
      }
    },

    async onPaymentSuccess(paymentData) {
      try {
        this.$emit('package-upgraded', {
          package: this.selectedPackage,
          isAnnual: this.isAnnual,
          payment: paymentData
        });

        this.closePaymentModal();
        this.closeModal();

      } catch (error) {
      }
    },

    /**
     * Pending payment mode'da bu kart ödeme bekleniyor mu?
     */
    isPendingPackageCard(packageItem) {
      if (!this.isPendingPaymentMode || !packageItem) return false;
      return this.currentUserPackageId === packageItem.packageId;
    },

    isCurrentPlan(packageItem) {
      if (!packageItem || !packageItem.packageId) return false;
      // Sadece aktif VE ÖDENMİŞ bir pakette "current plan" sayılır.
      // İptal/expired/suspended/pending payment durumlarında kullanıcı paketi (yeniden) satın alabilmeli.
      const status = this.userPackageStatus?.status;
      const inactiveStatuses = ['expired', 'cancelled', 'suspended', 'demo_expired', 'package_expired'];
      if (status && inactiveStatuses.includes(status)) return false;
      if (this.userPackageStatus?.isUsed === true) return false;
      // Pending payment: paket aktif gözüküyor ama henüz ödenmemiş — current plan sayma
      if (this.userPackageStatus?.urgency === 'payment_pending'
          || this.userPackageStatus?.pendingPayment === true) return false;
      return this.currentUserPackageId === packageItem.packageId;
    },

    isDowngrade(packageItem) {
      if (!packageItem || !this.currentPackage) return false;
      if (packageItem.isEnterprise) return false;
      if (this.isCurrentPlan(packageItem)) return false;

      // Demo paketten her pakete geçilebilir (demo bir referans seviye değil).
      if (this.currentPackage.isDemo === true) return false;

      // Aksi durumda sortOrder karşılaştır — paket aktif/expired/cancelled olsa da
      // alt seviyeli bir pakete asla geçilemez.
      const currentSortOrder = this.currentPackage.sortOrder || 0;
      const targetSortOrder = packageItem.sortOrder || 0;

      return currentSortOrder > targetSortOrder;
    },

    getButtonDisplayText(packageItem) {
      if (!packageItem) return this.$t('choose_plan_btn');
      if (this.isUpgrading) return this.$t('loading');
      // Pending payment'taki paket için özel buton text
      if (this.isPendingPackageCard(packageItem)) return this.$t('payment_pending_pay_button');
      if (this.isCurrentPlan(packageItem)) return this.$t('current_plan');
      if (packageItem.isEnterprise) return this.$t('contact_us');
      if (this.isDowngrade(packageItem)) return this.$t('downgrade_not_available');

      switch (this.urgency) {
        case 'expired':
          return this.$t('choose_plan_btn');
        case 'critical':
          return this.$t('upgrade_now');
        case 'overdue':
          return this.$t('complete_payment');
        default:
          return this.$t('switch_to_plan');
      }
    },
    shouldShowBothIcons(packageItem) {
      if (!packageItem || !packageItem.name) return false;

      const name = packageItem.name.toLowerCase();

      return name.includes('gelişmiş') || name.includes('kurumsal');
    },

  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
}

.modal-container {
  background: #ffffff;
  border-radius: 24px;
  width: 1150px;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  position: relative;
}

.modal-header {
  padding: 70px 32px 24px;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  margin-bottom: 10px;
}

.modal-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  font-family: 'euclid_medium', 'sans-serif';
}

.modal-subtitle {
  color: #666666;
  margin: 0;
  font-size: 12px;
  line-height: 1.5;
}

.close-button {
  position: absolute;
  top: 24px;
  right: 24px;
  background: #f5f5f5;
  border: none;
  cursor: pointer;
  color: #666666;
  padding: 8px;
  border-radius: 50%;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  height: 36px !important;
  width: 36px !important;
}

.toggle-section {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 5px;
  flex-direction: column;
  padding-right: 30px;
}

.discount-badge {
  background: #3da33e;
  color: white;
  padding: 6px 12px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  height: 20px;
  justify-content: center;
  align-items: center;
  font-family: 'euclid-regular','sans-serif';
}

.annual-toggle {
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
  align-items: center;
}

.toggle-label {
  font-size: 12px;
  color: #666666;
  transition: color 0.2s;
  font-weight: 500;
}

.toggle-label.active {
  color: #1a1a1a;
  font-weight: 600;
}

.pricing-cards {
  display: grid;
  grid-template-columns: repeat(3, 345px);
  gap: 20px;
  justify-content: center;
  margin-bottom: 25px;
}

.pending-info-bar {
  background: #FEF0C7;
  border: 1px solid #FEDF89;
  color: #B54708;
  padding: 12px 20px;
  border-radius: 8px;
  margin: 0 auto 20px auto;
  max-width: 1100px;
  font-size: 13px;
  font-family: euclid_medium, sans-serif;
  text-align: center;
}

.pending-package-highlight {
  border: 2px solid #DC6803 !important;
  box-shadow: 0 4px 20px rgba(220, 104, 3, 0.15);
}

.pending-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #DC6803;
  color: white;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 11px;
  font-family: euclid_semi_bold, sans-serif;
  white-space: nowrap;
  z-index: 1;
}

.pricing-card {
  border-radius: 20px;
  padding: 24px;
  background: #f9fafb;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  flex-direction: column;
  height: 552px;
  width: 345px;
}

.pricing-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
}

.pricing-card.current-plan {
  background: #f8f9ff;
}

.plan-header {
  margin-bottom: 24px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  justify-content: space-between;
}

.plan-icon {
  margin-bottom: 16px;
}

.plan-name-wrapper {
  display: flex;
  flex-direction: column;
}

.plan-name {
  font-size: 20px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px 0;
}

.plan-description {
  color: #666666;
  font-size: 14px;
  margin: 0;
  line-height: 1.5;
}

.pricing-section {
  margin-bottom: 24px;
}

.price-container {
  display: flex;
  gap: 2px;
  align-items: center;
}

.currency {
  font-size: 36px;
  font-weight: 600;
  color: #1a1a1a;
}

.price {
  font-size: 36px;
  font-weight: 700;
  color: #1a1a1a;
}

.period {
  color: #525866;
  font-size: 12px;
  font-weight: 500;
}

.price-try {
  color: #868C98;
  font-size: 13px;
  margin-top: 4px;
  font-weight: 500;
}

.upgrade-pricing .original-price {
  display: flex;
  gap: 2px;
  align-items: baseline;
  margin-bottom: 2px;
}

.upgrade-pricing .original-currency {
  font-size: 14px;
  color: #868C98;
  font-weight: 500;
}

.upgrade-pricing .price-strikethrough {
  font-size: 14px;
  font-weight: 500;
  color: #868C98;
  text-decoration: line-through;
}

.upgrade-pricing .original-period {
  color: #868C98;
  font-size: 11px;
}

.upgrade-pricing .upgrade-amount {
  margin-bottom: 2px;
}

.upgrade-pricing .upgrade-amount .price {
  color: #3DA33E;
}

.upgrade-pricing .upgrade-amount .currency {
  color: #3DA33E;
}

.upgrade-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 4px 10px;
  border-radius: 8px;
  background: rgba(61, 163, 62, 0.08);
  font-size: 12px;
  color: #3DA33E;
  font-weight: 400;
}

.upgrade-badge strong {
  font-weight: 600;
}

.upgrade-addons-note {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin-top: 6px;
  padding: 6px 10px;
  border-radius: 8px;
  background: rgba(21, 112, 239, 0.08);
  font-size: 11px;
  color: #175CD3;
  font-weight: 400;
  line-height: 1.4;
  text-align: left;
}

.upgrade-addons-note svg {
  flex-shrink: 0;
  margin-top: 2px;
}

.custom-pricing {
  height: 38px;
  display: flex;
  align-items: center;
}

.custom-price {
  font-size: 20px;
  color: #666666;
  font-family: 'euclid_medium', 'sans-serif';
}

.plan-button-wrapper {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: flex-start;
}

.plan-button {
  border-radius: 12px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  margin-bottom: 12px;
  border: none;
  display: flex;
  height: 32px;
  width: 124px;
  justify-content: center;
  align-items: center;
}

.plan-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.plan-button:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.plan-button.primary {
  background: #1c3cd5;
  color: white;
}

.plan-button.primary:hover:not(:disabled) {
  background: #1631b3;
}

.plan-button.current {
  background: #f0f0f0;
  color: #666666;
  cursor: default;
}

.plan-button.enterprise {
  background: #040c2d;
  color: white;
}

.plan-button.enterprise:hover:not(:disabled) {
  background: #0f1a47;
}

.billing-info-wrapper {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: center;
  margin-bottom: 15px;
}

.billing-info {
  color: #666666;
  font-size: 12px;
}

.features-section {
  flex: 1;
  margin-bottom: 24px;
}

.features-title {
  font-size: 14px;
  font-family: 'euclid_medium', 'sans-serif';
  color: #101728;
  margin: 0 0 16px 0;
}

.features-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.features-list li {
  display: flex;
  align-items: flex-start;
  gap: 3px;
  margin-bottom: 5px;
  font-size: 12px;
  color: #525866;
}

.device-icons {
  display: flex;
  gap: 8px;
  color: #999999;
  margin-top: auto;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.error-message {
  background: #fee;
  color: #c33;
  padding: 12px 24px;
  margin: 0 24px 24px;
  border-radius: 8px;
  border: 1px solid #fcc;
  text-align: center;
  font-size: 14px;
}

.plan-button.current-disabled {
  background: #f0f0f0 !important;
  color: #666666 !important;
  cursor: not-allowed !important;
  border: 1px solid #e0e0e0 !important;
}

.plan-button.current-disabled:hover {
  background: #f0f0f0 !important;
  transform: none !important;
  box-shadow: none !important;
}

.pricing-card.current-plan .plan-button.current-disabled {
  background: #e8f0fe !important;
  color: #1c3cd5 !important;
  border: 1px solid #1c3cd5 !important;
  font-weight: 600;
  width: auto;
}

.plan-button.downgrade-disabled {
  background: transparent !important;
  color: #101828 !important;
  cursor: not-allowed !important;
  border: 1px solid #101828 !important;
  opacity: 0.6;
  width: auto;
}

.plan-button.downgrade-disabled:hover {
  background: transparent !important;
  transform: none !important;
  box-shadow: none !important;
}

@media (max-width: 1024px) {
  .pricing-cards {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

@media (max-width: 768px) {
  .modal-container {
    width: 95%;
    margin: 20px;
    border-radius: 20px;
  }

  .modal-header {
    padding: 24px 20px;
    flex-direction: column;
    align-items: flex-start;
  }

  .toggle-section {
    width: 100%;
    align-items: flex-end;
    padding-right: 0;
  }

  .pricing-cards {
    padding: 20px;
  }
}
</style>
